export default __webpack_public_path__ + "static/media/套餐要求.10794767.png";